export const LEARN_MORE_ABOUT_BENEFITS_JSM_URL =
	'https://www.atlassian.com/software/jira/service-management/pricing';

export const LEARN_MORE_ABOUT_BENEFITS_JPD_URL =
	'https://www.atlassian.com/software/jira/product-discovery/pricing';

export const LEARN_MORE_ABOUT_BENEFITS_JSW_URL = 'https://www.atlassian.com/software/jira/pricing';

export const REFERRER_JSM = 'jsm';

export const REFERRER_JPD = 'jpd';

export const REFERRER_JSW = 'jsw';
